<template lang='pug'>
  v-content
    v-container(fluid)
      v-flex
        v-card
          v-toolbar(color='white')
            v-toolbar-title(v-model="title") {{ title }}
            v-divider(class="mx-2" inset vertical)
            v-spacer
          v-divider
          EwaskatExtendList(
            :title='title' 
            :dialogType='dialogType'
            :ip='getIp()'
          )
</template>

<script>
import * as config from "../config/index.json";
import EwaskatExtendList from "@/components/EwaskatExtendList.vue";
import { mapGetters, mapState } from "vuex";
import helper from "../helper/index.js";
export default {
  name: "EwaskatExtend",
  components: {
    EwaskatExtendList,
  },
  data () {
    return {
      config: config.default,
      title: 'Perpanjang E-Waskat',
      dialogType: 'approval',
      ip: {
        headers: [
          {
            text: 'Nomor',
            align: 'start',
            value: 'ipNo',
            width: '160px',
            sortable: false,
          },
          { text: 'Judul Pekerjaan', value: 'ipJudulPekerjaan',width: '210px' },
          { text: 'Tanggal', value: 'ipDateFormat' },
          { text: 'Perusahaan', value: 'ipPerusahaan' },
          { text: 'Nama Pemegang Izin', value: 'ipPemegangIzin.name',width: '170px' },
          { 
            text: 'Status', 
            value: 'ipStatusLabel', 
            align: 'center', 
            width: '120px',
            sortable: false,
          },
          { 
            text: 'Action', 
            value: 'actions',
            sortable: false, 
          },
          { text: '', value: 'data-table-expand' }
        ],
        items: [],
      },
    }
  },
  mounted () {
    this.$store.dispatch("fetchExtendEwaskatList")
  },
  computed: {
    ...mapState(["extendEwaskatList","API_URL"]),
    ...mapGetters(['userAuth']) // get user data login with combine leave user
  },
  methods: {
    getWITADate:helper.getWITADate,
    formatDate:helper.formatDate,
    getIp() {
      this.ip.items = this.$store.state.extendEwaskatList.data;
      this.ip.jumlah = this.$store.state.extendEwaskatList.jumlah;
      const desiredStatus = this.$store.state.extendEwaskatList.desiredStatus;
      const isAuthenticated = this.$store.getters.isAuthenticated;
      const isKTT = this.userAuth.group_level?.includes('KTT') || false;

      if (!this.ip.items) return this.ip;
      for (let i = 0; i < this.ip.items.length; i++) {
        let setIpStatusLabel = null;
        let setIpStatusColor = null;
        
        if(this.ip.items[i].ipExtendStatus == 10) {
          const closer = this.ip.items[i].ipPengesahan?.ipWorkflow.find(val => val.status == 9).matrix.some(wf => this.userAuth.group_level?.includes(wf));
          if((desiredStatus.includes(20) || desiredStatus.includes(-1)) && closer){
              setIpStatusLabel = "Need Closing";
              setIpStatusColor = 9;
          }
        } else if (this.ip.items[i].ipExtendStatus == 2) {
          const workflow = this.ip.items[i].ipExtendWorkflow;
          const correctLocation = this.ip.items[i].ipLocation[0].code === this.userAuth.location;
          const correctDepartment = Array.isArray(this.userAuth.department)
            ? this.userAuth.department.includes(this.ip.items[i].ipDeptDivisi)
            : (this.userAuth.department === this.ip.items[i].ipDeptDivisi);
          const correctCompanies = this.userAuth.companies?.includes(this.ip.items[i].ipPerusahaan) || false;
          
          // const isCheckCompany = !["DIVHEADHSE","KTT","PNC"].some(el => this.userAuth.companies?.includes(el)); // selain "DIVHEADHSE","KTT","PNC" perlu check company
          // const isCheckDeptAndLoc = !this.userAuth.location.includes('MITRA') && !this.userAuth.group_level?.includes('KTT');
          
          for (const wf of workflow) {
            const correctGroupLevel = wf.matrix.some(el => this.userAuth.group_level?.includes(el));

            // cek role apakah user perlu validasi semua rule
            const needFullValidation = ['SAFETYMITRA','PJO'];
            const filterRole = this.userAuth.group_level.filter( el => !needFullValidation.includes(el));
            const fullValidation = needFullValidation.some( el => this.userAuth.group_level.includes(el) ) && filterRole.length < 1; // cek apakah mempunyai role safetymitra dan pjo saja atau punya role yang lain

            if (wf.status !== 9 || !isAuthenticated || !correctGroupLevel) continue;
            
            if (isKTT) {
              setIpStatusLabel = this.config.status[wf.status].name;
              setIpStatusColor = wf.status;
            } else if (fullValidation && (correctGroupLevel && correctDepartment && correctLocation && correctCompanies)){
              setIpStatusLabel = this.config.status[wf.status].name;
              setIpStatusColor = wf.status;
            } else if (correctDepartment) {
              setIpStatusLabel = this.config.status[wf.status].name;
              setIpStatusColor = wf.status;
            }
          }
        }

        this.ip.items[i].ipStatusLabel = setIpStatusLabel ?? this.config.status[this.ip.items[i].ipExtendStatus].name;
        this.ip.items[i].ipStatusColor = setIpStatusColor ?? this.ip.items[i].ipExtendStatus;
        this.ip.items[i].ipDateFormat = this.formatDate(this.ip.items[i].ipExtendDate);
        this.ip.items[i].ipFormShortName = this.config.ShortenFormName[this.ip.items[i].ipForm];
      }

      return this.ip;
    },
  },
};
</script>